import { render } from "./collectionreport.vue?vue&type=template&id=c872d54a"
import script from "./collectionreport.vue?vue&type=script&lang=js"
export * from "./collectionreport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__